//Styles
import { RadioButton } from "primereact/radiobutton"
import { Checkbox } from "primereact/checkbox"

import assessFormStyles from "../../../../../styles/assessments/AssessmentForm.module.css"
import elementTypes from "../Elements/elementTypes"

export default function QuestionInputMatrixInput({
  question,
  label,
  option,
  answers,
  onChange,
  readOnly,
}) {
  let answer = undefined
  const radioTypeAnswerId = "radio"

  if (question.type === "matrix") {
    answer = answers?.find(
      (answerEntry) =>
        answerEntry.questionId === label.id &&
        answerEntry.optionId === radioTypeAnswerId
    )
  } else {
    answer = answers?.find(
      (answerEntry) =>
        answerEntry.questionId === label.id &&
        answerEntry.optionId === option.id
    )
  }

  const onChangeAnswer = (newValue) => {
    let useAnswers = answers ? answers : []

    if (answer) {
      answer.value = newValue
    } else {
      const optionId =
        question.type === elementTypes.matrixElementId
          ? radioTypeAnswerId
          : option.id

      useAnswers = [
        ...useAnswers,
        { questionId: label.id, optionId: optionId, value: newValue },
      ]
    }

    onChange(useAnswers)
  }

  return (
    <div className={assessFormStyles.matrixQuestionOption}>
      {question.type === "matrix" ? (
        <RadioButton
          checked={answer?.value === option.id}
          onChange={(e) => {
            if (answer?.value !== option.id) {
              onChangeAnswer(option.id)
            }
          }}
        />
      ) : (
        <Checkbox
          checked={answer?.value === true}
          onChange={(e) => {
            onChangeAnswer(e.checked)
          }}
          disabled={readOnly}
          className={assessFormStyles.matrixQuestionOptionRadio}
        />
      )}
    </div>
  )
}
